<template>
  <main>

    <div class="container">
      <section class="section">
        <div class="section__block">
          <h1 class="text-center">Veranstaltung erstellen</h1>
        </div>
        <div class="section__block">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-8">
              <div class="alert alert-danger" v-if="errorMessage" role="alert">
                {{ errorMessage }}
              </div>
              <div class="alert alert-success" v-if="successMessage" role="alert">
                {{ successMessage }}
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-12 col-lg-8">
              <form @submit.prevent="submit">
                <div class="mb-4">
                  <label for="datepicker">Veranstaltungsdatum</label>
                  <input ref="datepickerRef" type="date" class="form-control" name="eventDate" id="eventDate" />
                </div>
                <div class="mb-4">
                  <label for="labelForHeader" class="form-label">Überschrift</label>
                  <input type="text" class="form-control" name="title" id="title" v-model="title" placeholder="Überschrift hier eintragen">
                </div>
                <div class="mb-4">
                  <label for="labelForEventsText" class="form-label">Inhalt</label>
                  <textarea class="form-control" name="text" id="text" rows="10" v-model="text" placeholder="Inhalt für neue Veranstaltung"></textarea>
                </div>
                <div class="mb-4">
                  <label for="labelForLink" class="form-label">Link (optional)</label>
                  <input type="text" class="form-control" name="link" id="link" v-model="link" placeholder="möglicher link">
                </div>
                <div class="d-flex justify-content-center">
                  <button type="submit" class="btn btn-primary">Absenden</button>
                </div>
              </form>
            </div>
          </div>
          </div>
      </section>
      </div>
  </main>
</template>
<script>
import { onMounted, ref } from "vue";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { German } from "flatpickr/dist/l10n/de.js";
import axios from "axios";

export default {
  setup() {
    const datepickerRef = ref(null);
    const title = ref('');
    const text = ref('');
    const link = ref('');
    const errorMessage = ref('');
    const successMessage = ref('');

    const submit = async () => {
      // Validate form fields
      if (!datepickerRef.value || !title.value || !text.value) {
        errorMessage.value = 'Bitte füllen Sie die Pflichtfelder aus!';
        return;
      }

      const formData = new FormData();

      if(link.value && !link.value.startsWith('http')) {
        errorMessage.value = 'Der Link muss mit "http://" oder "https://" beginnen.';
        return;
      }

      // Append regular fields
      formData.append("eventDate", datepickerRef.value.value);
      formData.append("title", title.value);
      formData.append("text", text.value);
      formData.append("link", link.value);

      // Submit form (simulating an API call)
      try {
        // Uncomment this when you implement the API request
        await axios.post('http://localhost:8082/gemeinde/events', formData);

        // Reset form after successful submission
        datepickerRef.value = null;
        title.value = '';
        text.value = '';
        link.value = '';
        errorMessage.value = '';

        successMessage.value = 'Veranstaltung wurde erfolgreich erstellt!';
      } catch (error) {
        errorMessage.value = 'Ein Fehler ist aufgetreten';
        console.error(error);
      }
    };

    onMounted(() => {
      flatpickr(datepickerRef.value, {
        dateFormat: "d.m.Y",
        locale: German,
        altInput: true,
        altFormat: "j F Y",
        minDate: "today"
      });
    });

    return {
      datepickerRef,
      submit,
      title,
      text,
      link,
      errorMessage,
      successMessage,
    };
  }
};
</script>
